import script from "./Phone_List_Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone_List_Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Phone_List_Dialog.vue?vue&type=style&index=0&id=49b5bcc0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b5bcc0"]])

export default __exports__